import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import GuamanPoma from "../../../images/modulo14/guamanpoma.png";
import Escritura from "../../../images/modulo14/escritura2.png";

const Actividad7 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[8];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[9].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[9].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[7].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[7].path}`,
  };

  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 p-md-5 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-3 text-center">
            <img
              src={GuamanPoma}
              className="bg-white img-fluid rounded"
              alt="Guaman Poma"
            />
          </div>
          <div className="col-md-9 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>El poder de la escritura</strong>
            </h4>
            <p className="mt-1">
              Una gran diferencia entre el castellano, que era el idioma de los
              conquistadores, y las lenguas originarias del Perú, es que el
              primero podía <strong>escribirse y leerse</strong>.
            </p>
          </div>

          <div className="col-md-9 p-md-3 p-0">
            <p>
              Ninguna de las lenguas originarias del Perú tenía un{" "}
              <strong>sistema de escritura</strong> cuando llegaron los
              españoles. Ello llevó a que los conquistadores asumieran que su
              idioma era mejor.
            </p>
            <p>
              Definitivamente, que una lengua pueda escribirse tiene muchas
              ventajas, pero eso no la convierte en superior a otra.
            </p>
          </div>
          <div className="col-md-3 text-center">
            <img
              src={Escritura}
              className="bg-white img-fluid rounded"
              alt="Escritura"
            />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado: El poder de la escritura. Pida que
            describan las ilustraciones. Comente que la primera imagen trata del
            famoso episodio en que los españoles le muestran un texto escrito
            (la biblia) al inca Atahualpa. La segunda ilustración muestra el
            asombro de los incas ante la escritura. Comente que el texto leído
            menciona que, entre varias razones, el castellano se impuso por
            tener escritura. Ello ha llevado, de forma errada, a que algunos
            piensen que, en el Perú, el castellano es mejor o superior a las
            lenguas originarias.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
